"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Connection_1 = __importStar(require("./Connection"));
var ConnectionInterface_1 = __importDefault(require("./ConnectionInterface"));
var Logger_1 = __importDefault(require("../Logger"));
var HTTPRequest_1 = __importDefault(require("./HTTPRequest"));
var HttpConnection = /** @class */ (function (_super) {
    __extends(HttpConnection, _super);
    function HttpConnection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'http';
        _this.readyStateInt = 1;
        _this.increment = 1;
        _this.onLoad = function () {
            var _a = _this.connection, status = _a.status, response = _a.response;
            if (status === 200) {
                _this.emit(Connection_1.ConnectionEvents.MESSAGE, _this.id, { data: _this.connection.responseHandler(response) });
            }
            else {
                _this.emit(Connection_1.ConnectionEvents.ERROR, _this.id, { code: status, reason: null });
            }
        };
        _this.downloadResponseHandler = function (response) { return response; };
        _this.uploadResponseHandler = function () { return "upload ".concat(_this.expected()); };
        _this.pingResponseHandler = function (response) {
            var timePassed = ((new Date()).getTime() - _this.connection.startTime) / 1000;
            var responseParts = ['challenge'];
            if (response !== 'start ok') {
                responseParts.push(timePassed);
            }
            responseParts.push(_this.increment);
            return responseParts.join(' ');
        };
        return _this;
    }
    HttpConnection.prototype.ready = function () {
        this.emit(Connection_1.ConnectionEvents.OPEN, this.id);
    };
    HttpConnection.prototype.readyState = function () {
        return this.readyStateInt;
    };
    // eslint-disable-next-line class-methods-use-this
    HttpConnection.prototype.bufferedAmount = function () {
        return 0;
    };
    HttpConnection.prototype.createConnection = function () {
        var _this = this;
        this.connection = new HTTPRequest_1.default();
        this.increment += 1;
        this.connection.onload = this.onLoad;
        this.connection.onerror = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.emit.apply(_this, __spreadArray([Connection_1.ConnectionEvents.ERROR, _this.id], args, false));
        };
        this.connection.onabort = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.emit.apply(_this, __spreadArray([Connection_1.ConnectionEvents.CLOSE, _this.id], args, false));
        };
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.connection.responseHandler = function () { };
        this.expected(0);
    };
    HttpConnection.prototype.download = function (amount) {
        this.createConnection();
        try {
            var url = "".concat(this.protocol, "://").concat(this.serverUrl, "/bigfile.bin?t=").concat(this.ticket, "&len=").concat(amount, "&id=").concat(this.testId, "&b=").concat(Math.random());
            this.connection.responseHandler = this.downloadResponseHandler;
            this.connection.open('GET', url, true);
            this.connection.responseType = 'arraybuffer';
            this.connection.send();
            this.downloads += 1;
        }
        catch (ex) {
            Logger_1.default.log('Failed to download', ex);
        }
    };
    HttpConnection.prototype.upload = function (buffer, expected) {
        this.createConnection();
        try {
            this.expected(expected);
            var url = "".concat(this.protocol, "://").concat(this.serverUrl, "/cgi/upload.cgi?t=").concat(this.ticket, "&id=").concat(this.testId, "&b=").concat(Math.random());
            this.connection.responseHandler = this.uploadResponseHandler;
            this.connection.open('POST', url, true);
            this.connection.responseType = 'arraybuffer';
            this.connection.send(buffer);
            this.uploads += 1;
        }
        catch (ex) {
            Logger_1.default.log('Failed to upload', ex);
        }
    };
    HttpConnection.prototype.ping = function (type) {
        this.createConnection();
        var url = "".concat(this.protocol, "://").concat(this.serverUrl, "/pingpong/").concat(type, "?t=").concat(this.ticket);
        this.connection.responseHandler = this.pingResponseHandler;
        this.connection.startTime = (new Date()).getTime();
        this.connection.open('GET', url, true);
        this.connection.send();
        this.pings += 1;
    };
    HttpConnection.prototype.close = function () {
        this.readyStateInt = 0;
        try {
            this.connection.abort();
        }
        catch (ex) {
            Logger_1.default.log('Failed to abort connection', ex);
        }
    };
    return HttpConnection;
}(Connection_1.default));
exports.default = HttpConnection;
//# sourceMappingURL=HttpConnection.js.map